import { render, staticRenderFns } from "./PaymentsHistory.vue?vue&type=template&id=75cf9dae&"
import script from "./PaymentsHistory.vue?vue&type=script&lang=js&"
export * from "./PaymentsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports